module.exports = __webpack_public_path__ + "static/media/Daenerys Targaryen.7f96a001.jpg";